<script setup lang="ts">
const localePath = useLocalePath();
const { formatLink } = useInternationalization(localePath);
</script>

<template>
  <nav class="relative bg-dark">
    <div class="border-b-1 border-secondary-100 py-6">
      <div class="container mx-auto">
        <div class="flex justify-between items-center md:justify-start px-4 md:space-x-10">
          <div class="flex justify-start lg:w-0 lg:flex-1 space-x-4 md:space-x-0">
            <NuxtLink :to="formatLink(`/`)" class="inline-block">
              <img class="h-8" src="assets/images/logo-invert.svg" alt="Logo" />
            </NuxtLink>
          </div>
          <AccountMenu />
        </div>
      </div>
    </div>
  </nav>
</template>
